export default __webpack_public_path__ + "static/4-19bfaef7993c971a957b5017092a66f6.jpg";